export default __webpack_public_path__ + "static/media/life-insurance-benefit-disabled.4377fe98.png";